import { Typography } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { NotConfiguredProps } from './types'

/**
 * @see {@link NotConfiguredProps}
 */
const NotConfigured: React.FC<NotConfiguredProps> = (props) => {
  const eventName = useCIMSNotificationsPanelContext().event.name
  return props.type === 'every' ? (
    <Typography.Text>
      No Recipients have been configured to receive an email for every{' '}
      {eventName} event, on every Concrete Test Set
    </Typography.Text>
  ) : (
    <Typography.Text>
      No Recipients have been configured to receive an email for {eventName}{' '}
      events where {props.itemName} is the {props.groupName} of the Concrete
      Test Set
    </Typography.Text>
  )
}

export default NotConfigured
